import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './CaffaInfoModal.css';

interface Props {
    isOpen: boolean;
    onClose: () => void;
}

const CaffaInfoModal: React.FC<Props> = ({ isOpen, onClose }) => {
    const { t } = useTranslation('knowledgeGraph');

    useEffect(() => {
        if (!isOpen) return;
        const onKey = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', onKey);
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', onKey);
            document.body.style.overflow = prevOverflow;
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    const bullets = t('caffa.info.bullets', { returnObjects: true }) as string[];

    return (
        <div className="caffa-info-overlay" onClick={onClose} role="dialog" aria-modal="true">
            <div className="caffa-info-modal" onClick={(e) => e.stopPropagation()}>
                <button
                    className="caffa-info-close"
                    onClick={onClose}
                    aria-label={t('caffa.info.close')}
                >
                    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                </button>

                <h2 className="caffa-info-title">{t('caffa.info.title')}</h2>
                <p className="caffa-info-desc">{t('caffa.info.description')}</p>

                {Array.isArray(bullets) && bullets.length > 0 && (
                    <ul className="caffa-info-bullets">
                        {bullets.map((b, i) => (
                            <li key={i}>
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                    <polyline points="20 6 9 17 4 12" />
                                </svg>
                                <span>{b}</span>
                            </li>
                        ))}
                    </ul>
                )}

                <div className="caffa-info-actions">
                    <Link
                        to="/knowledge-graph/caffa"
                        className="caffa-info-cta"
                        onClick={onClose}
                    >
                        {t('caffa.info.learnMore')}
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <line x1="5" y1="12" x2="19" y2="12" />
                            <polyline points="12 5 19 12 12 19" />
                        </svg>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default CaffaInfoModal;
